const initState = {
  isLoading: false,
  isDeleteLoading: false,
  isUpdateLoading: false,
  feedbackLoader: false,
  platform_feedbacks: null,
  hasMoreFeedbacks: true,
  restaurantsData: [],
  restaurantsDetail: {},
  restaurantsRestData: null,
  restaurantMedia: {},
  merchantData: [],
};

const restaurantReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_RESTAURANT":
      return {
        ...state,
        restaurantsData: action.payload,
      };
    case "GET_RESTAURANT_DATA":
      return {
        ...state,
        restaurantsDetail: action.payload,
      };
    case "GET_ALL_MERCHANT":
      return {
        ...state,
        merchantData: action.payload,
      };
    case "RESTAURANT_DETAILS":
      return {
        ...state,
        restaurantsRestData: action.payload,
      };
    case "RESTAURANT_LOADER":
      return {
        ...state,
        isLoading: action.payload,
      };
    case "RESTAURANT_DELETE_LOADER":
      return {
        ...state,
        isDeleteLoading: action.payload,
      };
    case "RESTAURANT_UPDATE_LOADER":
      return {
        ...state,
        isUpdateLoading: action.payload,
      };
    case "RESTAURANT_MEDIA":
      return {
        ...state,
        restaurantMedia: action.payload,
      };

    case "DELETE_RESTAURANT":
      return {
        ...state,
        restaurantsData: state.restaurantsData.filter(
          (restaurant) => restaurant.id !== action.payload
        ),
      };
    case "UPDATE_RESTAURANT":
      return {
        ...state,
        restaurantsData: state.restaurantsData.map((restaurant) =>
          restaurant.id === action.payload.id
            ? { ...restaurant, ...action.payload }
            : restaurant
        ),
      };
    case "PLATFORM_FEEDBACKS":
      return {
        ...state,
        platform_feedbacks: action.payload,
      };
    case "FEEDBACK_LOADER":
      return {
        ...state,
        feedbackLoader: action.payload,
      };
    case "SET_HAS_MORE_FEEDBACKS":
      return {
        ...state,
        hasMoreFeedbacks: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default restaurantReducer;
